import React from 'react'
// import ".Css/style.css"
import "../Css/globalStyles.css"
import "../Css/style.css"
import Carousel from './Carousel'
import AboutUs from './AboutUs2'
import Services2 from './Services2'
import Contact2 from './Contact/Contact'
import Inspiration from './inspiration'
import NavBar3 from './Navbar3'
function Home() {
  return (


    <div>

      <Carousel />
      <Services2 />
      <AboutUs />

      <Inspiration />



    </div>
  )
}

export default Home